import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the API
 */
export class DataHandlerService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getDataHandlers(visibiltyType) {	
		var params = '';
		if (visibiltyType) {
			params = '?visibiltyType=' + encodeURIComponent(visibiltyType);
		}
		var data = await this.makeGETRequest('/api/resource/data-handlers/all' + params);		
		return data;
	}	
	
	async getCompanyDataHandler(dataType, module) {
		var params = '';
		if (dataType) {
			params = 'dataType=' + dataType + (module ? '&module=' + module : '');
		} else {
			params = (module ? '&module=' + module : '');
		}		
		
		var data = await this.makeGETRequest('/api/resource/data-handlers?' + params);		
		return data;
	}	
	
	async getDataHandler(handlerId) {
		var data = await this.makeGETRequest('/api/resource/data-handlers/' + encodeURIComponent(handlerId));		
		return data;
	}
	
	async getDataHandlerCompanies(handlerId) {
		var data = await this.makeGETRequest('/api/resource/data-handlers/' + encodeURIComponent(handlerId) + '/companies');		
		return data;
	}	
	
	async addCompanyToHandler(addModel) {
		var saved = await this.makePOSTRequest('/api/resource/data-handlers', addModel);
		return saved;
	}	
	
	async removeCompanyFromHandler(handlerId, companyId) {
		var data = await this.makeDELETERequest(
			'/api/resource/data-handlers/' + encodeURIComponent(handlerId) + '/companies/' + encodeURIComponent(companyId)
		);		
		return data;		
	}

	async saveVisibilityOverride(handlerId, visibilityType) {
		var saved = await this.makePUTRequest(
			'/api/resource/data-handlers/visibility-override/' + encodeURIComponent(handlerId),
			{ visibilityType: visibilityType }
		);
		return saved;
	}

	async clearVisibilityOverride(handlerId) {
		var data = await this.makeDELETERequest(
			'/api/resource/data-handlers/visibility-override/' + encodeURIComponent(handlerId)
		);
		return data;
	}

	async getDataHandlerUsers(handlerId) {
		var data = await this.makeGETRequest(
			'/api/resource/data-handlers/' + encodeURIComponent(handlerId) + '/users'
		);
		return data;
	}

	async addUserToHandler(handlerId, username) {
		var saved = await this.makePOSTRequest(
			'/api/resource/data-handlers/' + encodeURIComponent(handlerId) + '/users/' + encodeURIComponent(username),
			{}
		);
		return saved;
	}

	async removeUserFromHandler(handlerId, username) {
		var data = await this.makeDELETERequest(
			'/api/resource/data-handlers/' + encodeURIComponent(handlerId) + '/users/' + encodeURIComponent(username)
		);
		return data;
	}
	
}
